import { useLocation, useNavigate } from 'react-router';

import { Container, StickyHeaderWithBreadcrumbs } from '@/_components';
import type { RouteRecordsType } from '@/_navigation';
import { ROUTES } from '@/_navigation';
import { VideoPlayer } from '@/_prep-portal/onboarding/@shared';

interface VideoState {
  name: string;
  videoUrl: string;
}
const pages = [ROUTES.HELP, ROUTES.VIDEO_PLAYER_PAGE] as RouteRecordsType[];

export default function Page() {
  const location = useLocation();
  const nav = useNavigate();

  const { name, videoUrl } = (location.state as VideoState) || {};

  if (!videoUrl) {
    nav(ROUTES.HELP.path);
  }
  return (
    <>
      <StickyHeaderWithBreadcrumbs title={name} pages={pages} backLink={ROUTES.HELP.path} />
      <Container>
        {/* <div className="min-h-screen px-16"> */}
        {/* <Header /> */}
        {/* <Text
            as="caption-medium-bold"
            className="my-8 mb-2 flex items-center justify-center font-serif text-3xl text-primary"
          >
            {name}
          </Text> */}
        <main className="flex flex-1 items-center justify-center px-16">
          <VideoPlayer url={videoUrl} isOnBoarding={false} onComplete={() => console.log('Video Completed')} />
        </main>
        {/* </div> */}
      </Container>
    </>
  );
}
